module.exports = __webpack_public_path__ + "static/img/kongtiao-zhire-active.7579ca0e.png";